import { CueAnalytics } from '@cuemath/analytics-v2';
import * as Sentry from '@sentry/react';

const USER_TYPE = 'ADMIN';
const logEnabled = false;

const CONFIG = {
  environment: process.env.NODE_ENV === 'staging' ? 'TESTING' : 'PRODUCTION',
  appId: 'leap-admin.cuemath.com',
  appVersion: '0.0.0',
  userType: USER_TYPE,
  logEnabled,
};

const createAnalyticsWorker = () => {
  const cdnPublicPath = __webpack_public_path__;

  __webpack_public_path__ = '/';

  try {
    if (window.SharedWorker) {
      return new SharedWorker(
        new URL('@cuemath/analytics-v2/shared-worker', import.meta.url),
      );
    }

    return new Worker(new URL('@cuemath/analytics-v2/worker', import.meta.url));
  } finally {
    __webpack_public_path__ = cdnPublicPath;
  }
};

const NOOP_ANALYTICS = {
  login: () => {},
  logout: () => {},
  trackEvent: () => {},
};

const createAnalytics = () => {
  try {
    return new CueAnalytics({ ...CONFIG, worker: createAnalyticsWorker() });
  } catch (error) {
    Sentry.captureException(error);

    return NOOP_ANALYTICS;
  }
};

export const analytics = createAnalytics();

export const trackEvent = async (eventName, attributes, overrides) => {
  analytics.trackEvent(eventName, attributes, overrides);
};
